import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Carouselhome from '../home/carousel-home';
import GdMuseum1 from '../../images/Project_Images/GdMuseum1.webp';
import GdMuseum2 from '../../images/Project_Images/GdMuseum2.webp';
import GdMuseum3 from '../../images/Project_Images/GdMuseum3.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function ProjectGdMuseum() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    return (
        <>
            <Helmet>
                <title>About Our GD Museum - Experimenta Science Centre Acoustics Project</title>
                <meta name="description" content="" />
                <meta property="og:title" content="GD Museum - Experimenta Science Centre" />
                <meta property="og:description" content="Supplied Polysorb acoustic clouds." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/GdMuseum1.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-gd-museum" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-gd-museum" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={GdMuseum1} className="img-fluid" alt="GdMuseum1" />
                                            </div>
                                            <div className="slide">
                                                <img src={GdMuseum2} className="img-fluid" alt="GdMuseum2" />
                                            </div>
                                            <div className="slide">
                                                <img src={GdMuseum3} className="img-fluid" alt="GdMuseum3" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch slider-arrow" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch slider-arrow" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>GD Museum - Experimenta Science Centre</h3>
                                    <p className="note">Location: Coimbatore, TamilNadu </p>
                                    <p><strong>About GD Museum - Experimenta Science Centre Acoustic Project</strong>
                                        <br />GD Museum - Experimenta Centre is a pioneering interactive science hub in Coimbatore, designed to ignite curiosity and foster hands-on learning. As part of the GD Museums, Experimenta offers a world-class science experience, blending education with exploration through 120+ engaging exhibits. At Experimenta, visitors of all ages can independently explore various scientific concepts at their own pace, making learning fun, immersive, and intuitive, where science comes to life through STEM-based interactive display.<br />
                                    </p>
                                    <p>
                                        <strong>Our Scope</strong>
                                        <br />In this project, we conducted a testing and supplied Polysorb acoustic clouds, designed in hexagon and triangle shapes and in three distinct colors. By integrating Polysorb clouds, we delivered aesthetic yet functional acoustic solutions that complemented the museum’s innovative and experiential environment, fostering an engaging atmosphere for visitors.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    )
}

export default ProjectGdMuseum